import React, { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import './Prices.css';

function Prices() {
  useEffect(() => {
    document.title = 'Prices | Sapium Beauty - Laser Hair Removal & Skin Treatment Prices';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        'content',
        'Transparent prices for laser hair removal and advanced skin treatments at Sapium Beauty in East London (28 Barking Rd, E16 1EQ). View prices for women and men, course packages and special offers.'
      );
    }
  }, []);
  const [womenPricesOpen, setWomenPricesOpen] = useState(false);
  const [menPricesOpen, setMenPricesOpen] = useState(false);
  const { t } = useTranslation();

  const toggleWomenPrices = () => setWomenPricesOpen(prev => !prev);
  const toggleMenPrices = () => setMenPricesOpen(prev => !prev);

  return (
    <div className="prices-page">
      <section className="prices-hero">
        <div className="container">
          <h1>{t('prices.hero.title')}</h1>
          <p>{t('prices.hero.description')}</p>
        </div>
      </section>

      <section className="prices-section">
        <div className="container">
          <div style={{ marginBottom: '2rem', padding: '1rem', background: '#f8f9fa', borderRadius: '8px', textAlign: 'center' }}>
            <p style={{ margin: '0.5rem 0', fontWeight: '600' }}>Skin Treatments Prices</p>
            <p style={{ margin: '0.5rem 0', fontSize: '0.95rem' }}>
              For the most up-to-date skin treatment pricing, please visit our Fresha page.
            </p>
            <a
              href="https://www.fresha.com/book-now/sapium-beauty-hu8f8ild/all-offer?share=true&pId=2743251"
              target="_blank"
              rel="noopener noreferrer"
              className="service-detail-button"
              style={{ width: 'auto', padding: '0.875rem 2rem' }}
            >
              View prices on Fresha
            </a>
          </div>
          <div style={{ marginBottom: '2rem', padding: '1rem', background: '#f8f9fa', borderRadius: '8px', textAlign: 'center' }}>
            <p style={{ margin: '0.5rem 0', fontWeight: '600' }}>Laser Hair Removal Prices</p>
            <p style={{ margin: '0.5rem 0', fontSize: '0.95rem' }}>Location: {t('services.locations.laserHairRemoval')}</p>
          </div>
          <div className="price-section">
            <button className="price-toggle" onClick={toggleWomenPrices}>
              {t('prices.categories.women')}
            </button>
            {womenPricesOpen && (
              <table className="price-table">
                <thead>
                  <tr>
                    <th>{t('prices.tableHeaders.service')}</th>
                    <th>{t('prices.tableHeaders.session1')}</th>
                    <th>{t('prices.tableHeaders.session3')}</th>
                    <th>{t('prices.tableHeaders.session6')}</th>
                    <th>{t('prices.tableHeaders.session8')}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{t('prices.services.women.upperLip')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£25</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£70</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£130</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£170</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.women.chin')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£25</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£70</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£130</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£170</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.women.neck')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£25</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£70</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£130</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£170</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.women.fullFace')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£60</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£170</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£320</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£410</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.women.halfLegs')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£70</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£200</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£370</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£480</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.women.fullLegs')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£110</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£310</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£580</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£750</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.women.underarms')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£30</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£85</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£160</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£200</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.women.halfArms')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£50</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£140</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£260</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£340</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.women.fullArms')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£70</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£200</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£370</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£480</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.women.tummyLine')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£35</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£100</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£190</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£240</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.women.brazilian')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£55</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£155</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£290</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£375</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.women.hollywood')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£75</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£215</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£400</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£520</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.women.fullFront')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£50</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£140</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£260</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£340</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.women.fullBack')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£50</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£140</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£260</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£340</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.women.platinumPackage')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£445</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£1335</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£2400</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£3000</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.women.goldPackage')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£345</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£1035</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£1552.50</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£1932</td>
                  </tr>
                </tbody>
              </table>
            )}
          </div>

          <div className="price-section">
            <button className="price-toggle" onClick={toggleMenPrices}>
              {t('prices.categories.men')}
            </button>
            {menPricesOpen && (
              <table className="price-table">
                <thead>
                  <tr>
                    <th>{t('prices.tableHeaders.service')}</th>
                    <th>{t('prices.tableHeaders.session1')}</th>
                    <th>{t('prices.tableHeaders.session3')}</th>
                    <th>{t('prices.tableHeaders.session6')}</th>
                    <th>{t('prices.tableHeaders.session8')}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{t('prices.services.men.chin')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£30</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£85</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£160</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£200</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.men.ears')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£30</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£85</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£160</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£200</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.men.eyebrows')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£15</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£40</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£75</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£95</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.men.nose')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£30</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£85</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£160</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£200</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.men.sideburns')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£40</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£110</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£210</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£270</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.men.fullFace')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£65</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£185</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£350</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£450</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.men.neck')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£50</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£140</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£260</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£340</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.men.beardSculpting')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£80</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£225</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£425</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£550</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.men.faceNeck')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£90</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£255</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£480</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£620</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.men.halfLegs')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£99</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£280</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£530</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£680</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.men.fullLegs')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£150</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£425</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£800</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£1000</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.men.buttocks')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£60</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£170</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£320</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£410</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.men.maleBrazilian')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£55</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£155</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£290</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£375</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.men.feetToes')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£50</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£140</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£260</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£340</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.men.underarms')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£30</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£85</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£160</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£200</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.men.halfArms')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£65</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£185</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£350</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£450</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.men.fullArms')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£99</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£280</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£530</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£680</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.men.shoulders')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£30</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£85</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£160</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£200</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.men.stomach')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£55</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£155</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£290</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£375</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.men.chest')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£90</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£255</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£480</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£620</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.men.halfBack')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£99</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£280</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£530</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£680</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.men.fullBack')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£145</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£410</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£775</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£1000</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.men.chestStomach')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£130</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£370</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£700</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£900</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.men.backShoulders')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£165</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£465</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£880</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£1120</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.men.maleFullBody')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£445</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£1335</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£2400</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£3000</td>
                  </tr>
                </tbody>
              </table>
            )}
          </div>

        </div>
      </section>
    </div>
  );
}

export default Prices;
